import { ApiClient } from "../config/axiosConfig";
import { IPartNumberHistoryResponseDto } from "../models/History";

export const historyService = {
  getHistoryByPartNumberId: async (partNumberId: number) => {
    const res = await ApiClient.GET<IPartNumberHistoryResponseDto>(
      `warehouse/history?partNumberId=${partNumberId}`
    );
    return res;
  },
};
